import { h, Component } from 'preact';
import HTML from 'components/core/html/html';
import Close from 'components/bolt/icons/close';
import { joinClasses } from 'utils/utils';
import Store from 'store/store';
import s from 'components/bolt/hub/components/hubTextOverlay/hubTextOverlay.sss';

export default class HubTextOverlay extends Component {
	componentDidUpdate(prevProps) {
		if (prevProps.show !== this.props.show) {
			Store.emit('HUB_TEXT_OVERLAY_SHOW', this.props.show);
		}
	}

	render({ content, show, closeOverlay }) {
		return (
			<div class={joinClasses(s.container, show && s.show)}>
				<div class={s.bgGradient} onClick={closeOverlay} />
				<HTML
					class={s.content}
					markdown
					content={content}
				/>
				<button class={s.closeBtn} onClick={closeOverlay}>
					<Close class={s.close} />
				</button>
			</div>
		);
	}
}